import React, {useCallback, useMemo, useRef, useState} from "react";
import InputForm from "../../../../components/input/input-form.jsx";
import {Card} from "../../../../components/card/card.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../utils/aggrid-utils.js";

const LaneSelect = ({ label, lanes = [], onSelectionChange }) => {
    const [search, setSearch] = useState("");

    const gridRef = useRef(null);
    const theme = useMemo(() => aggridUtils.generalTheme(), []);

    const filteredLanes = useMemo(() => {
        if (!search) return lanes;

        const s = search.toLowerCase();

        return lanes.filter(l => {
            const description = [l.route, l.laneObservation]
                .filter(Boolean)
                .join(" ");

            const fullText = `${l.capturePlace} (${l.id} - ${description})`.toLowerCase();

            return fullText.includes(s);
        });
    }, [lanes, search]);

    const columnDefs = useMemo(() => [
        { headerName: "", checkboxSelection: true, width: 40 },
        { headerName: "Descrição", flex: 1,
            valueGetter: params => {
                const { id, capturePlace, route, laneObservation } = params.data;
                const description = [route, laneObservation].filter(Boolean).join(" ");

                return `${capturePlace} (${id} - ${description})`;
            }
        }
    ], []);

    const defaultColDef = useMemo(() => ({
        sortable: true,
        resizable: true,
        tooltipValueGetter: params => params.value ?? ""
    }), []);

    const onSelectionChanged = useCallback(() => {
        const selectedNodes = gridRef.current.api.getSelectedNodes();
        const selectedData = selectedNodes.map(node => node.data);

        onSelectionChange?.(selectedData);
    }, [onSelectionChange]);

    return (
        <div className="flex flex-col w-full h-full gap-2">
            <Card className="flex-1 flex flex-col overflow-hidden min-h-0">
                <Card.Header>
                    <Card.Title>{label}</Card.Title>
                </Card.Header>

                <Card.Body className="flex-1 p-0 flex flex-col min-h-0">
                    <div className="sticky top-0 z-10 bg-white mb-2">
                        <InputForm
                            label="Pesquisar"
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            classNameWrapper="w-full"
                        />
                    </div>

                    <div className="ag-theme-alpine h-[400px]">
                        <AgGridReact
                            ref={gridRef}
                            rowData={filteredLanes}
                            columnDefs={columnDefs}
                            defaultColDef={defaultColDef}
                            rowSelection="multiple"
                            rowMultiSelectWithClick={true}
                            suppressRowClickSelection={false}
                            animateRows={false}
                            tooltipShowDelay={200}
                            onSelectionChanged={onSelectionChanged}
                            suppressCellFocus
                            gridOptions={{ localeText: aggridUtils.localization() }}
                            theme={theme}
                        />
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
};

export default LaneSelect;